import { Camera } from '@phosphor-icons/react';
import { Button } from '@vake/ui-kit';
import { Feature } from 'geojson';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { EOBrowserService, getEOBrowserUrl } from '../../../utils/eobrowser';
import { VesselInfo } from './overwatch-vessel-info';
import { SendToMattermost } from './send-to-mattermost';

export const PathfinderChosenImage: FC<{
    boatMetaData: Feature | null;
    chosenImage: number | null;
    chosenDate: string | null;
    chosenTime: string | null;
    setChosenImage: (value: number | null) => void;
    setBoatMetaData: (value: Feature | null) => void;
    reportName: string | null;
}> = ({ boatMetaData, setBoatMetaData, reportName }) => {
    const getUrl = (service: EOBrowserService) => {
        return getEOBrowserUrl({
            date: boatMetaData!.properties!.timestamp.slice(0, 10),
            lat: boatMetaData!.properties!.lat,
            lng: boatMetaData!.properties!.lon,
            imageSource: boatMetaData!.properties!.image_source,
            service: service,
            zoom: 15,
        });
    };

    return (
        <>
            <VesselInfo
                selectedFeature={boatMetaData}
                setSelectedFeature={setBoatMetaData}
                hideOrderReportImage
            ></VesselInfo>
            <div className="flex flex-wrap gap-2 p-2 justify-center">
                <Link to={getUrl('sentinelhub')} target="_blank">
                    <Button variant="neutral" text="Open In SentinelHub" />
                </Link>
                <Link to={getUrl('copernicus')} target="_blank">
                    <Button variant="neutral" text="Open in Copernicus" />
                </Link>
                {boatMetaData?.properties && (
                    <SendToMattermost
                        textOnButton="Order Report Image"
                        iconOnButton={<Camera size={16} />}
                        textToSend={`Report Image Ordered. old pathfinder so no uuid. report=${reportName}, time=${boatMetaData.properties.timestamp}, lat=${boatMetaData.properties.lat}, lon=${boatMetaData.properties.lon}, mmsi=${boatMetaData.properties.mmsi}, image_source=${boatMetaData.properties.image_source}`}
                        successMessage={`Thank you, we've received your order. We'll send you the image soon.`}
                    />
                )}
            </div>
        </>
    );
};
